import React from "react";
import { CurbiqIcons } from "./CurbiqIcons";

const iconKeys = [
    "accessibility",
    "add_icon",
    "add_button_icon",
    "analyser_icon",
    "arcadis_logo",
    "area_icon",
    "arrow_narrow",
    "calender_icon",
    "check",
    "check_circle",
    "check_icon",
    "chevron_icon",
    "close",
    "close_icon",
    "collapsible_icon",
    "create_regulation_icon",
    "cursor_click_icon",
    "custom_zone_icon",
    "currency_dollar_circle_icon",
    "danger_icon",
    "default_empty_state",
    "download_icon",
    "edit_icon",
    "edit_button_icon",
    "edit_zone_icon",
    "ev_state",
    "excel_icon",
    "eye",
    "eye_off",
    "expand_icon",
    "geoJSON_icon",
    "info_icon",
    "line_asset",
    "mail_icon",
    "multiple_select_icon",
    "list_view_icon",
    "mail_icon",
    "map_icon",
    "no_files_empty_state",
    "paid_parking",
    "pdf_icon",
    "permit_parking",
    "point_asset",
    "polygon_asset",
    "radius_icon",
    "remove_circle_icon",
    "save_icon",
    "settings_icon",
    "settings_02",
    "trash_icon",
    "unselected_empty_state",
    "warning_icon",
    "x_circle"
] as const;

type IconKeys = (typeof iconKeys)[number];

export type AllIcons = Record<IconKeys, React.ReactNode>;

export const curbiqIcons: AllIcons = Object.fromEntries(
    iconKeys.map((key) => [key, CurbiqIcons[key]])
) as AllIcons;

export interface IconProps {
    icon: keyof AllIcons | string;
    width?: any;
    height?: any;
    viewBox?: string;
    fill?: string;
    stroke?: string;
    stroke_width?: string;
    className?: string;
    style?: any;
    pathStroke?: string;
    pathFill?: string;
    svgbackgroundColor?: string;
    isLargeIcon?: boolean;
    rotateIcon?: string;
    id?: string;
    isSmallIcon?: boolean;
}
